import React from 'react';
import { ExternalLink } from 'lucide-react';
import { adSurfaceEnabled } from '../../config/ads';
import { adSlotVisible } from '../../utils/adsEnabled';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import { Root, Img, Body, Top, Sponsored, Sponsor, H, Desc, Cta } from './AdSidebar.styled';

/** Sponsored card with image + copy. Works with static assets or managed campaign-mapped `ad` objects. */
export default function AdSidebar({ ad, pageKey, onLinkClick }) {
  if (!adSurfaceEnabled() || (pageKey && !adSlotVisible(pageKey)) || !ad?.image) return null;

  const dest = isValidAdDestination(ad.url);
  const href = dest ? ad.url : '#';
  const onClick = (e) => {
    if (!dest) e.preventDefault();
    else onLinkClick?.(e);
  };

  return (
    <Root
      href={href}
      onClick={onClick}
      target={dest ? '_blank' : undefined}
      rel={dest ? 'noopener noreferrer sponsored' : undefined}
    >
      <Img src={ad.image} alt={ad.title} loading="lazy" decoding="async" />
      <Body>
        <Top>
          <Sponsored>Sponsored</Sponsored>
          <Sponsor>{ad.sponsor}</Sponsor>
        </Top>
        <H>{ad.title}</H>
        <Desc>{ad.description}</Desc>
        <Cta>
          {ad.cta} <ExternalLink size={10} />
        </Cta>
      </Body>
    </Root>
  );
}
